import { endpoint } from "../../../utils/constants";

const enterpriseLogin = `${endpoint}/auth/empresa/login`;
const adesao = `${endpoint}/contracts?id_empresa=`;
const adesaoAccept = `${endpoint}/contracts/pre-contract/updated`;
const getEmails = `${endpoint}/email/all?cpf_cnpj=`;
const sendEmail = `${endpoint}/email/send-email`;
const resetPswd = `${endpoint}/email/reset-password`;
const getData = `${endpoint}/contracts/associated/`;
const createNewUser = `${endpoint}/contracts/person/create`;
const endSheet = `${endpoint}/contracts/pre-contract/bulk`;
const plansByContract = `${endpoint}/contracts/club/cpfCnpj/`;
const plansByContractPF = `${endpoint}/contracts/club/all/`;
const cancelContractPFPJ = `${endpoint}/contracts/cancel-contract`;
const listContractsPlans = `${endpoint}/contracts/adhesions/cpf?num_contrato=`;
const listCancelContract = `${endpoint}/contracts/cancellation/requests?id_convenio=`;
const destroyContract = `${endpoint}/contracts/cancel-contract-agreed`;
const listCanceledPlans = `${endpoint}/contracts/plans/disable?id_convenio=`;
const listPlanChange = `${endpoint}/contracts/change/plan?id_convenio=`;
const acceptInvite = `${endpoint}/contracts/change/plan/accept`;

export const enterpriseLoginRequest = async (
  user: String,
  pswd: String
): Promise<any> => {
  try {
    const response = await fetch(enterpriseLogin, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
      },
      body: JSON.stringify({
        user_login: user,
        password: pswd,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const responseData = await response.json();

    console.log(responseData, "Retorno API enterpriseLoginRequest");

    return responseData;
  } catch (error) {
    console.error("Erro na requisição de login da empresa:", error);
    throw error;
  }
};

export const fetchAdesao = async (enterpriseId: String) => {
  console.log(`${adesao}${enterpriseId}&aceite=NULL`, "Manda")
  const response = await fetch(`${adesao}${enterpriseId}&aceite=NULL`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
    },
  });

  const responseData = await response.json();

  console.log(responseData, "Retorno API Lista Adesões");

  return responseData;
};

export const fetchAdesaoFiltered = async (
  enterpriseId: String,
  filter: string,
  startDate: string,
  endDate: string
) => {
  const response = await fetch(
    `${adesao}${enterpriseId}&aceite=${filter}&start_date=${startDate}&end_date=${endDate}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
      },
    }
  );

  const responseData = await response.json();

  console.log(responseData, "Retorno API Lista Adesões filtrada");

  return responseData;
};

export const acceptAdesao = async (
  id: number[],
  accept: string,
  reason: string
): Promise<any> => {
  try {
    const response = await fetch(adesaoAccept, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
      },
      body: JSON.stringify({
        id: id,
        Aceite: accept,
        motivo: reason,
      }),
    });

    console.log(
      "Mandando",
      JSON.stringify({
        id: id,
        Aceite: accept,
        motivo: reason,
      })
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const responseData = await response.json();

    console.log(responseData, "Retorno API acceptAdesao");

    return responseData;
  } catch (error) {
    console.error("Erro na requisição de Aceitar adesão", error);
    throw error;
  }
};

export const fetchEmails = async (cpj: String) => {
  const response = await fetch(`${getEmails}${cpj}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
    },
  });

  const responseData = await response.json();

  console.log(responseData, "Retorno API fetch emails");

  return responseData;
};

export const setEmail = async (
  email: string,
  cpfCnpj: string
): Promise<any> => {
  console.log(
    JSON.stringify({
      email: email,
      cpfCnpj: cpfCnpj,
    })
  );
  try {
    const response = await fetch(sendEmail, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
      },
      body: JSON.stringify({
        email: email,
        cpfCnpj: cpfCnpj,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const responseData = await response.json();

    console.log(responseData, "Retorno API set email");

    return responseData;
  } catch (error) {
    console.error("Erro na requisição de set email", error);
    throw error;
  }
};

export const resetPasword = async (
  token: string,
  code: number,
  newPassword: string,
  bearerToken: string
): Promise<any> => {
  try {
    const response = await fetch(resetPswd, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${bearerToken}`,
      },
      body: JSON.stringify({
        token: token,
        code: code,
        newPassword: newPassword,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const responseData = await response.json();

    console.log(responseData, "Retorno API reset pasword");

    return responseData;
  } catch (error) {
    console.error("Erro na requisição de reset", error);
    throw error;
  }
};

export const fetchUserData = async (cpf_cnpj: String) => {
  const response = await fetch(`${getData}${cpf_cnpj}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
    },
  });

  const responseData = await response.json();

  console.log(responseData, "Retorno API fetchUserData");

  return responseData;
};

export const createUser = async (
  name: string,
  cpf: string,
  cep: string,
  street: string,
  number: string,
  comp: string,
  neighborhood: string,
  cityId: number,
  ufId: number,
  email: string,
  cellphone: string,
  id_clube: string,
  dt_nascimento: string
): Promise<any> => {
  console.log(JSON.stringify({
    nome: name,
    cpf: cpf,
    cep: cep,
    logradouro: street,
    numero: number,
    complemento: comp,
    bairro: neighborhood,
    id_cidade: cityId,
    uf: ufId,
    EMAIL_COB: email,
    CELULAR_COB: cellphone,
    id_clube: id_clube,
    dt_nascimento: dt_nascimento,
  }), "Enviando createUser")
  try {
    const response = await fetch(createNewUser, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
      },
      body: JSON.stringify({
        nome: name,
        cpf: cpf,
        cep: cep,
        logradouro: street,
        numero: number,
        complemento: comp,
        bairro: neighborhood,
        id_cidade: cityId,
        uf: ufId,
        EMAIL_COB: email,
        CELULAR_COB: cellphone,
        id_clube: id_clube,
        dt_nascimento: dt_nascimento,
      }),
    });

    const responseData = await response.json();

    console.log(responseData, "Retorno API createUser");

    if (!response.ok) {
      const errorMessage =
        responseData?.message || responseData?.error || `Erro ao criar usuário`;
      throw new Error(errorMessage);
    }

    return responseData;
  } catch (error: any) {
    console.error("Erro na requisição de createUser", error);

    if (error.message) {
      throw error;
    }

    throw new Error("Erro ao conectar com o servidor. Tente novamente.");
  }
};

export const sendSheet = async (data: []): Promise<any> => {
  console.log(data, "Envio Sendsheet")
  try {
    const response = await fetch(endSheet, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
      },
      body: JSON.stringify({
        data: data,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const responseData = await response.json();

    console.log(responseData, "Retorno API sendSheet");

    return responseData;
  } catch (error) {
    console.error("Erro na requisição de sendSheet", error);
    throw error;
  }
};

export const fetchPlansByContract = async (cnpj: String) => {
  const response = await fetch(`${plansByContract}${cnpj}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
    },
  });

  const responseData = await response.json();

  console.log(responseData, "Retorno API fetchPlansByContract");

  return responseData;
};

export const fetchContracstPF = async (cpf: String) => {
  const response = await fetch(`${plansByContractPF}${cpf}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
    },
  });

  const responseData = await response.json();

  console.log(responseData, "Retorno API fetchPlansByContractPF");

  return responseData;
};

export const cancelContract = async (
  contract_id: number,
  reason: number,
  description: string
) => {
  try {
    const response = await fetch(cancelContractPFPJ, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
      },
      body: JSON.stringify({
        id_contrato: contract_id,
        motivo: reason,
        observacao: description,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const responseData = await response.json();

    console.log(responseData, "Retorno API cancelContract");

    return responseData;
  } catch (error) {
    console.error("Erro na requisição de cancelContract", error);
    throw error;
  }
};

export const fetchContractsByNumberAndCpf = async (
  contratId: string,
  cpf: string
) => {
  const response = await fetch(`${listContractsPlans}${contratId}&cpf=${cpf}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
    },
  });

  const responseData = await response.json();

  console.log(responseData, "Retorno API Lista Adesões filtrada");

  return responseData;
};

export const fetchListOfCancelationRequest = async (contratId: string) => {
  const response = await fetch(`${listCancelContract}${contratId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
    },
  });

  const responseData = await response.json();

  console.log(responseData, "Retorno API fetchListOfCancelationRequest");

  return responseData;
};

export const endCancelRequest = async (
  data: { id_contrato: number; motivo: number; observacao: string }[]
): Promise<any> => {
  console.log(data, "Cancel")
  try {
    const response = await fetch(destroyContract, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
      },
      body: JSON.stringify({ data }),
    });

    console.log("Enviando:", JSON.stringify({ data }));

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const responseData = await response.json();

    console.log("Retorno API cancelamento de contrato:", responseData);

    return responseData;
  } catch (error) {
    console.error("Erro na requisição de cancelamento de contrato:", error);
    throw error;
  }
};

export const fetchListOfCanceledPlans = async (contratId: string) => {
  const response = await fetch(`${listCanceledPlans}${contratId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
    },
  });

  const responseData = await response.json();

  console.log(responseData, "Retorno API fetchListOfCanceledPlans");

  return responseData;
};

export const fetchListOfChangedPlans = async (agreementId: string) => {
  console.log(`${listPlanChange}${agreementId}`, "Mandando PLanos")
  const response = await fetch(`${listPlanChange}${agreementId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
    },
  });

  const responseData = await response.json();

  console.log(responseData, "Retorno API fetchListOfChangedPlans");

  return responseData;
};

export const acceptChangePlanInvite = async (
  id: number[],
  accept: string
): Promise<any> => {
  try {
    const response = await fetch(acceptInvite, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
      },
      body: JSON.stringify({
        id: id,
        aceite: accept,
      }),
    });

    console.log(
      "Mandando",
      JSON.stringify({
        id: id,
        aceite: accept,
      })
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const responseData = await response.json();

    console.log(responseData, "Retorno API acceptChangePlanInvite");

    return responseData;
  } catch (error) {
    console.error("Erro na requisição de Aceitar solicitação de planos", error);
    throw error;
  }
};
